import { useI18n } from "@/i18n";
import { PageHero } from "@/pages/PageHero";
import { DocCards } from "@/components/home/DocsTeaser";
import { img } from "@/lib/gallery";

export default function DocsIndex() {
  const { t } = useI18n();
  return (
    <div data-testid="docs-index-page">
      <PageHero eyebrow={`MB300 · by NELVIS FRANCE · ${t.docs.eyebrow}`} title={t.docs.title} image={img(6)} />
      <section className="container-x pb-28"><DocCards /></section>
    </div>
  );
}
